import {
  getActivityLog,
  getClientNotes,
  addClientNotes,
  getExternalActivityLog,
  getMessagesLogByCustomer,
} from "@/http/customer/customer";
import { rechargeCdrNotificationDataApi } from "@/http/customer/customer";

export default {
  namespaced: true,
  state: {
    activityLogList: [],
    externalActivityLogList: [],
    notes: [],
    cdrData: [],
    rechargeData: [],
    clientMessageLogList: [],
    notificationData: [],
    slcData: [],
    spendData: [],
  },
  actions: {
    async getActivityLogList({ commit }, data) {
      const resp = await getActivityLog(data.id, data.fromDate, data.toDate);
      commit("SET_ACTIVITY_LOG", resp.data.pageItems);
      return resp;
    },
    async getExternalActivityLogListAction({ commit }, data) {
      const resp = await getExternalActivityLog(
        data.id,
        data.fromDate,
        data.toDate
      );
      commit("SET_EXTERNAL_ACTIVITY_LOG", resp.data.pageItems);
      return resp;
    },
    async fetchRechargeCdrNotification({ commit }, data) {
      const resp = await rechargeCdrNotificationDataApi(data);
      if (data.type == "recharge") {
        commit("SET_RECHARGE_DATA", resp.data);
      }
      if (data.type == "cdr") {
        commit("SET_CDR_DATA", resp.data);
      }
      if (data.type == "notification") {
        commit("SET_NOTIFICATION_DATA", resp.data);
      }
      if (data.type == "slc") {
        commit("SET_SLC_DATA", resp.data);
      }
      if (data.type == "spend") {
        commit("SET_SPEND_DATA", resp.data.activityDetails.spendCapDetails);
      }
      return resp;
    },
    async getClientNotesAction({ commit }, data) {
      const resp = await getClientNotes(data);
      commit("SET_CLIENT_NOTES", resp.data);
      return resp;
    },
    async getMessagesLogByCustomerAction({ commit }, id) {
      const resp = await getMessagesLogByCustomer(id);
      commit("SET_CLIENT_MESSAGE_LOG_LIST", resp.data);
      return resp;
    },
    async addClientNotesAction(_, data) {
      return await addClientNotes(data.id, data.note);
    },
  },
  mutations: {
    SET_ACTIVITY_LOG(state, payload) {
      state.activityLogList = payload;
    },
    SET_RECHARGE_DATA(state, payload) {
      state.rechargeData = payload;
    },
    SET_CDR_DATA(state, payload) {
      state.cdrData = payload;
    },
    SET_NOTIFICATION_DATA(state, payload) {
      state.notificationData = payload;
    },
    SET_SLC_DATA(state, payload) {
      state.slcData = payload;
    },
    SET_SPEND_DATA(state, payload) {
      state.spendData = payload;
    },
    SET_EXTERNAL_ACTIVITY_LOG(state, payload) {
      state.externalActivityLogList = payload;
    },
    SET_CLIENT_NOTES(state, payload) {
      state.notes = payload;
    },
    SET_CLIENT_MESSAGE_LOG_LIST(state, payload) {
      state.clientMessageLogList = payload;
    },
  },
  getters: {
    getClientEditBillId(state) {
      return state.clientsDataEditId;
    },
    getClientBillId(state) {
      return state.clientsDataId;
    },
  },
};
